<style>

  /* Video background */

.videobg {
    width: 100%; /* Set video container element width here */
    height: 100%; /* Set video container element height here */
    overflow: hidden;
    background: #111; /* bg color, if video is not high enough */
  }

  /* horizontally center the video */
.videobg-width {
    position: absolute;
    width: 100%; /* Change width value to cover more area*/
    height: 100%;
    left: -9999px;
    right: -9999px;
    top: 0;
    overflow: hidden;
    margin: auto;
  }

  /* set video aspect ratio and vertically center */
.videobg-aspect {
    position: absolute;
    width: 100%;
    height: 0;
    top: -9999px;
    bottom: -9999px;
    margin: auto;
    padding-bottom: 56.25%; /* 16:9 ratio */
    overflow: hidden;

  }

.videobg-make-height {
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
  }

.videobg-hide-controls {
    box-sizing: content-box;
    position: relative;
    height: 100%;
    width: 100%;
    /* Vimeo timeline and play button are ~55px high */
    padding: 55px 97.7777px; /* 16:9 ratio */
    top: -55px;
    left: -97.7777px; /* 16:9 ratio */
  }

 .videobg iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: 0 none;
  }
</style>
<div class="videobg">
  <div class="videobg-width">
    <div class="videobg-aspect">
      <div class="videobg-make-height">
        <div class="videobg-hide-controls">
        </div>
      </div>
    </div>
  </div>
</div>
<app-rating-header
  [question]="question"
  [currentItem]="startAt"
  [count]="items.length">
</app-rating-header>
<app-media-play
  [shouldShowPlay]="showShowPlay"
  [underPlay]="underPlay"
  [duration]="duration"
  [currentTime]="currentTime"
  (played)="onPlay()">
</app-media-play>
<app-vote
  [showVote]="showVote"
  [currentItem]="startAt"
  [mediaType]="mediaType"
  [count]="items.length"
  [underPlay]="underPlay"
  (makeVote)="onVote($event)"
  (makeSubmitVote)="onSubmitVote($event)">
</app-vote>
<app-media-control
  [duration]="duration"
  [currentTime]="currentTime"
  [progressValue]="progressValue"
  [underPlay]="underPlay"
  (paused)="onPause($event)"
  (played)="onPlay()">
</app-media-control>
